<template>
  <div class="recharge_page">
    <img class="top_bg" src="@/assets/recharge/recharge_top_bg.png" alt="" />
    <Tabbar class="title" title="MetWallet" background="transparent" :show-back="false"></Tabbar>
    <div class="recharge_info_box">
      <img v-show="status === 0" class="status_pic" src="@/assets/recharge/waiting.png" alt="" />
      <img v-show="status === 1" class="status_pic" src="@/assets/recharge/success.png" alt="" />
      <img v-show="status === 2 || status === 3" class="status_pic" src="@/assets/recharge/fail.png" alt="" />
      <div v-show="status === 0" class="cost_amount">
        <span style="margin: 0">$</span>
        <span class="amount">{{ amount }}</span>
      </div>
      <div v-show="status === 1" class="success">
        <i18n path="rechargeAndTransfer.purchase_success" tag="span">
          <div class="diamond_box">
            <img class="diamond" src="@/assets/recharge/diamond.png" alt="" />
            {{ remark }}
          </div>
        </i18n>
      </div>
      <div v-show="status === 0" class="purchase_target">
        {{ $t('rechargeAndTransfer.purchase') }}
        <img class="diamond" src="@/assets/recharge/diamond.png" alt="" />
        {{ remark }}
      </div>
      <div v-show="status === 2 || status === 3" class="fail">
        {{ failReason }}
      </div>
    </div>
    <div class="recharge_btn" @click="onConfirm">
      {{ $t('common.confirm') }}
    </div>
    <CheckPayPassword :show="showKeyboard" v-bind:on-success="onPasswordSuccess" v-bind:on-close="onClose" />
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import CheckPayPassword from '@/components/CheckPayPassword'

export default {
  name: 'Recharge',
  data() {
    return {
      showKeyboard: false,
      amount: 0,
      merchantId: '',
      openId: '',
      appId: '',
      saltValue: '',
      remark: 0,
      merchantOrderNo: '',
      status: 0,
      failReason: ''
    }
  },
  components: {
    Tabbar,
    CheckPayPassword
  },
  methods: {
    onPasswordSuccess(value) {
      const params = {
        amount: this.amount,
        remark: this.remark,
        merchantId: this.merchantId,
        openId: this.openId,
        appId: this.appId,
        saltValue: this.saltValue,
        merchantOrderNo: this.merchantOrderNo,
        securityToken: value.securityToken
      }
      this.$http.post(window.serverPath + '/api/auth/payRechargeOrder', params).then((res) => {
        if (res.data.code === '200') {
          this.status = 1
        } else if (res.data.code === '61001') {
          this.status = 3
          this.failReason = res.data.message
        } else if (res.data.code === '100002') {
          this.status = 3
          this.failReason = ''
        } else {
          this.status = 2
          this.failReason = res.data.message
        }
        this.showKeyboard = false
      })
    },
    logout() {
      const $this = this
      this.$http
        .post(window.serverPath + '/api/auth/logout')
        .then((_res) => {
          $this.$store.commit('clearState')
          localStorage.removeItem('token')
          localStorage.removeItem('store')
          this.$router.push('/before-login')
        })
        .catch((err) => console.log('退出失败', err))
    },
    onClose() {
      this.showKeyboard = false
    },
    onConfirm() {
      if (this.status === 0) {
        this.showKeyboard = true
      } else if (this.status === 1 || this.status === 2) {
        try {
          if (window.close) {
            window.close()
          } else {
            window.location.href = 'about:blank'
          }
        } catch (e) {
          window.location.href = 'about:blank'
        }
      } else if (this.status === 3) {
        this.logout()
        this.$router.push('/before-login')
      }
    }
  },
  mounted() {
    this.amount = this.$route.query.amount
    this.merchantId = this.$route.query.merchantId
    this.openId = this.$route.query.openId
    this.appId = this.$route.query.appId
    this.saltValue = this.$route.query.saltValue
    this.remark = this.$route.query.remark
    this.merchantOrderNo = this.$route.query.merchantOrderNo
  }
}
</script>

<style scoped>
.recharge_page {
  width: 100%;
  height: 100vh;
  background: linear-gradient(180deg, #d9ffe8 0.35%, #fff 52.27%);
  position: relative;
}

.top_bg {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.recharge_info_box {
  margin-top: 0.8rem;
  width: 100%;
  height: 3.06rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.status_pic {
  width: 0.8rem;
  margin-bottom: 0.32rem;
}

.cost_amount {
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.36rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.44rem;
  display: flex;
  align-items: end;
  margin-bottom: 0.12rem;
}

.amount {
  color: #2f2f2f;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.6rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.56rem;
  margin-inline-start: 0.04rem;
}

.success {
  color: #3fbb70;
  font-size: 0.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.28rem;
}

.fail {
  color: #ff4c62;
  font-size: 0.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.28rem;
}

.purchase_target {
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.18rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.26rem;
  display: flex;
  align-items: center;
}

.diamond_box {
  display: flex;
  align-items: center;
  text-align: center;
}

.diamond {
  width: 0.2rem;
  height: 0.2rem;
  margin-inline-start: 0.06rem;
  margin-inline-end: 0.02rem;
}

.recharge_btn {
  display: flex;
  width: calc(100% - 0.36rem);
  height: 0.5rem;
  padding: 0.1rem;
  justify-content: center;
  align-items: center;
  margin: 0 0.18rem;
  color: #fff;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border-radius: 0.25rem;
  background: #3fbb70;
}
</style>

<style>
.title .tab {
  box-shadow: none !important;
}

.title .tab .tab_menu .tab_title {
  color: #2f2f2f !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Recharge.vue